import React from 'react';
import DocsLink from '../../../common/custom/DocsLink';
import VideoBox from '../../../common/custom/VideoBox';
const GoogleMap = () => {
  return (
    <>
      <h5>
        <b>Google Map</b>
      </h5>
      <p>
        Google Maps plugin allows you to integrate Google Maps in your web application. It allows
        you to display different locations using maps.
      </p>
      <br />
      <DocsLink link="https://academy.drapcode.com/docs/app-plugin/google-maps-plugin/" />
      <br />
      <h5>Videos</h5>
      <VideoBox
        videoLink="https://www.youtube.com/watch?v=i0Q3I942LIc"
        imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/GoogleMap.jpg"
        heading="Google Maps Integration"
      />
    </>
  );
};

export default GoogleMap;
